const CONFIG = {
  serverUrl: process.env.REACT_APP_SERVER_URL,
  tokenStorageName: 'UserToken',
  selectedCompanyStorageName: 'selectedCompany',
  selectedCompanyObjectStorageName: 'selectedCompanyObject',
  speed: process.env.REACT_APP_SPEED_KEY
};
export default CONFIG;


// WEBPACK FOOTER //
// ./src/util/config.js